module.exports = __webpack_public_path__ + "static/assets/0eab6235a1e9d8ff5beb1ecd80559ff5.png";